export default __webpack_public_path__ + "static/media/desensibilisierung_03.54bc8ae2.png";